import {
  SET_SORT_METHOD,
  SET_SELECTED_PLACE_ID,
  SET_LIMIT_AND_PAGE,
  SET_LAST_PAGE,
  SET_THEME_CATEGORIES,
  FILTER_CARD_BY_SEARCH_TERM,
  CLEAR_THEME_CONFIGS,
  SCHEMA_REMOVE_PLACES_THEMES,
} from './types';

export const setSortMethod = ({ theme, sortBy, sortOrder }) => {
  return {
    type: SET_SORT_METHOD,
    theme,
    sortBy,
    sortOrder,
  };
};

export const setSearchTerm = ({ searchTerm, theme }) => ({
  type: FILTER_CARD_BY_SEARCH_TERM,
  searchTerm,
  theme,
});

export const setSelectedPlaceId = ({ id }) => {
  return {
    type: SET_SELECTED_PLACE_ID,
    id,
  };
};

export const setLimtAndPage = ({ limit, page, theme }) => {
  return {
    type: SET_LIMIT_AND_PAGE,
    limit,
    page,
    theme,
  };
};

export const setLastPage = ({ theme }) => {
  return {
    type: SET_LAST_PAGE,
    theme,
  };
};

export const setThemeCategories = ({ categories, theme }) => {
  return {
    type: SET_THEME_CATEGORIES,
    categories,
    theme,
  };
};

export const clearThemeConfigs = ({ theme }) => {
  return {
    type: CLEAR_THEME_CONFIGS,
    theme,
  };
};

export const refreshThemeData = ({ theme, placeId }) => {
  return {
    type: SCHEMA_REMOVE_PLACES_THEMES,
    payload: {
      schema: 'places',
      placeId,
      theme,
    },
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/selectedPlaceActions.js